import _extends from 'babel-runtime/helpers/extends';

import { Navbar, Sidebar, AppMain } from './components';
import CRMAllCreate from '@/views/crm/components/CRMAllCreate';

import { mapGetters } from 'vuex';

export default {
  name: 'CrmLayout',

  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain,
    CRMAllCreate: CRMAllCreate
  },

  data: function data() {
    return {
      isCreate: false,
      createAction: null,
      createCRMType: ''

    };
  },


  computed: _extends({}, mapGetters(['crm', 'crmRouters']), {
    // 快捷添加
    quickAddList: function quickAddList() {
      var addItems = [];
      if (this.crm.leads && this.crm.leads.save) {
        addItems.push({
          icon: 'leads',
          index: 'leads',
          label: '线索'
        });
      }
      if (this.crm.customer && this.crm.customer.save) {
        addItems.push({
          icon: 'customer',
          index: 'customer',
          label: '客户'
        });
      }
      if (this.crm.contacts && this.crm.contacts.save) {
        addItems.push({
          icon: 'contacts',
          index: 'contacts',
          label: '联系人'
        });
      }
      if (this.crm.business && this.crm.business.save) {
        addItems.push({
          icon: 'business',
          index: 'business',
          label: '商机'
        });
      }

      if (this.crm.contract && this.crm.contract.save) {
        addItems.push({
          icon: 'contract',
          index: 'contract',
          label: '合同'
        });
      }
      if (this.crm.receivables && this.crm.receivables.save) {
        addItems.push({
          icon: 'receivables',
          index: 'receivables',
          label: '回款'
        });
      }
      if (this.crm.invoice && this.crm.invoice.save) {
        addItems.push({
          icon: 'invoice',
          index: 'invoice',
          label: '发票'
        });
      }
      if (this.crm.visit && this.crm.visit.save) {
        addItems.push({
          icon: 'house',
          index: 'visit',
          label: '回访'
        });
      }
      if (this.crm.product && this.crm.product.save) {
        addItems.push({
          icon: 'product',
          index: 'product',
          label: '产品'
        });
      }
      return addItems;
    },
    quickAddOffset: function quickAddOffset() {
      return Math.round(this.quickAddList.length / 2) * 25;
    }
  }),

  created: function created() {
    this.getcrmMessagNum();
  },
  mounted: function mounted() {},


  methods: {
    navClick: function navClick(index) {},
    addSkip: function addSkip(item) {
      this.createAction = {
        type: 'save',
        id: '',
        data: {}
      };
      this.createCRMType = item.index;
      this.isCreate = true;
    },


    /**
     * 获取消息数
     */
    getcrmMessagNum: function getcrmMessagNum() {
      this.$store.dispatch('GetMessageNum').then(function (res) {}).catch(function () {});
    },


    /**
     * 菜单钢鞭
     */
    handleSelect: function handleSelect() {
      this.$store.dispatch('GetMessageNum');
    },


    /**
     * 新建客户同时新建联系人
     */
    // 创建数据页面 保存成功
    createSaveSuccess: function createSaveSuccess(data) {
      if (data && data.createContacts) {
        if (data.type == 'customer') {
          this.createCRMType = 'contacts';
          this.createAction = {
            type: 'relative',
            crmType: 'customer',
            data: {
              customer: data.data
            }
          };
          this.isCreate = true;
        }
      }
    }
  }
};